export default __webpack_public_path__ + "static/media/illus16.4a3896ac.png";